import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

//primeReact
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
//components
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import CalendarInput from "../../../../../../components/input/CalendarInput";
//imports
import Modal from "../../../../../../components/modal/Modal";
import { searchInfoConvertedValue } from "../../../../../../services/Parcel/searchInfoConvertedValue";
import { anticipate } from "../../../../../../utils/anticipate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatCurrency } from "../../../../../../utils/formatCurrency";
import { formatDate } from "../../../../../../utils/formatDate";
import { sendAnticipateParcels } from "../../../../../../services/Parcel/sendAnticipateParcels";
import { useParcelContext } from "./ParcelContext";
import Excel from "../../../../../../assets/excel";


const ModalAnticipateSelectedInstallments = () => {
  const { control, handleSubmit: handleUpdateParcel, errors, reset } = useForm();

  const [isVisibleConfirm, setIsVisibleConfirm] = useState(false);
  const [isCalculateClicked, setIsCalculateClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAnticipateValueColumn, setShowAnticipateValueColumn] =
    useState(false);

  const {
    idSale,
    itemsSelected,
    setItemsSelected,
    setSelectAll,
    isModalVisibleAnticipateSelected,
    setIsModalVisibleAnticipateSelected,
    refetch,
  } = useParcelContext();

  const style = {
    width: window.innerWidth <= 992 ? "95vw" : "95vw",
  };

  const simplifiedParcels = itemsSelected.map((parcel) => ({
    ...parcel,
    description:
      parcel.description && parcel.description.name
        ? parcel.description.name
        : parcel.description,
  }));
  //COLUNAS DA TABELA 
  const columns = [
    { field: "id", header: "ID" },
    {
      field: "description",
      header: `Descrição`,
    },
    {
      field: "value",
      header: "Valor Parcela",
      body: (rowData) => formatCurrency(rowData.value),
    },

    {
      field: "due_date",
      header: "Data Vencimento",
      body: (rowData) => formatDate(rowData.due_date),
    },
  ];

  function sendUpdate(data) {
    setLoading(true);
    // eslint-disable-next-line no-unused-vars
    let parcelsAnticipate = simplifiedParcels;
    setIsCalculateClicked(true);
    const installments = simplifiedParcels.map((parcel) => parcel.id);
    console.log("Installments: ", installments);
    console.log("Simplified Parcels: ", simplifiedParcels);

    const result = {
      sale_id: idSale,
      action: "anticipate",
      installments: installments,
    };

    searchInfoConvertedValue(result)
      .then((dado) => {
        let parcelsAnticipate = { ...dado }; // Criando uma cópia do objeto 'dado'
        let totalParcelValue = 0;
        for (const key in dado) {
          if (Object.hasOwnProperty.call(dado, key) && !isNaN(parseInt(key))) {
            const parcel = dado[key];
            const processedParcel = {
              ...parcel,
              amortization_system: dado["amortization_system"],
              total_installments: dado["total_installments"],
              number_financing_installments:
                dado["number_financing_installments"],
              financing_value: dado["financing_value"],
              date_first_installment: dado["date_first_installment"],
              idSale: idSale,
              payment_date: data.payment_date.toISOString().split("T")[0],
              change_month_anticipation: dado["change_month_anticipation"],
              late_fee: dado["late_fee"],
              late_interest: dado["late_interest"],
            };
            const newResult = anticipate(processedParcel);
            parcelsAnticipate[key].anticipate_value = newResult;

            const newValueDiscount =
              parcelsAnticipate[key].value - newResult <= 0
                ? 0
                : parcelsAnticipate[key].value - newResult;

            parcelsAnticipate[key].newValueDiscount = newValueDiscount;
            // eslint-disable-next-line no-unused-vars
            totalParcelValue += newResult;
          }
        }
        // Remover as propriedades específicas do objeto 'parcelsAnticipate'
        delete parcelsAnticipate.amortization_system;
        delete parcelsAnticipate.change_month_anticipation;
        delete parcelsAnticipate.date_first_installment;
        delete parcelsAnticipate.financing_value;
        delete parcelsAnticipate.late_fee;
        delete parcelsAnticipate.late_interest;
        delete parcelsAnticipate.number_financing_installments;
        delete parcelsAnticipate.total_installments;
        setItemsSelected(Object.values(parcelsAnticipate));
      })
      .then(() => {
        setIsVisibleConfirm(true);
        setIsCalculateClicked(false);
        setShowAnticipateValueColumn(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erro ao buscar antecipação regressiva:", error);
      });
  }

  function sendAnticipate(data) {
    setIsModalVisibleAnticipateSelected(false);

    const sendArray = itemsSelected.map((item) => {
      return {
        id: item.id,
        discount: item.newValueDiscount,
      };
    });
    const sendData = {
      installments: sendArray,
      date_billet: data.payment_date.toISOString().split("T")[0],
    };

    const loadingNotification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    //Executar Antecipação das Parcelas
    sendAnticipateParcels(sendData)
      .then((result) => {
        // Verificar se a antecipação foi bem-sucedida
        if (result.success) {
          // Exibir notificação de sucesso
          toast.update(loadingNotification, {
            render:
              "Parcelas antecipadas com sucesso! Aguarde as parcelas estão sendo atualizadas...",
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "success",
            isLoading: false,
          });

          // Atualizar a lista após a conclusão da antecipação (opcional)
          refetch().then(() => {
            // Após a atualização, exibir notificação de sucesso
            toast.update(loadingNotification, {
              render: "Parcelas Atualizadas",
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              type: "success",
              isLoading: false,
            });
          });
        } else {
          const errorMessage =
            result.error && result.error
              ? result.error
              : "Não foi possível fazer a ação.";
          // Se houver um erro durante a antecipação de parcelas,
          // exibir uma notificação de erro
          toast.update(loadingNotification, {
            render: errorMessage,
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        console.log(error)
        const errorMessage =
          error.message && error.message
            ? error.message
            : "Não foi possível fazer a ação.";
        toast.update(loadingNotification, {
          render: errorMessage,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao antecipar parcelas:", error);
      });
    setItemsSelected([]);
    setSelectAll([]);
    setShowAnticipateValueColumn(false)
    reset();
  }


  const sumProperty = (array, prop) => {
    if (!Array.isArray(array)) {
      return 0;
    }

    return array.reduce((total, item) => {
      const value = parseFloat(item[prop]);
      return total + (isNaN(value) ? 0 : value);
    }, 0);
  };
  const totalValue = sumProperty(simplifiedParcels, "value");
  const totalAnticipate = sumProperty(simplifiedParcels, "anticipate_value");
  const totalDiscount = sumProperty(simplifiedParcels, "newValueDiscount");

  function exportToExcel() {
    const worksheetData = simplifiedParcels.map(parcel => ({
      'ID': parcel.id,
      'Descrição': parcel.description,
      'Valor da Parcela': formatCurrency(parcel.value),
      'Data de Vencimento': parcel.due_date,
      'Desconto': formatCurrency(parcel.newValueDiscount),
      'Valor Antecipado': formatCurrency(parcel.anticipate_value),
    }));

    // Adiciona a linha de totais
    worksheetData.push({
      'ID': '',
      'Descrição': 'Total:',
      'Valor da Parcela': formatCurrency(totalValue),
      'Data de Vencimento': '',
      'Desconto': formatCurrency(totalDiscount),
      'Valor Antecipado': formatCurrency(totalAnticipate),
    });

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Parcelas');

    XLSX.writeFile(workbook, 'antecipadas.xlsx');
  }

  function exportToPDF() {
    const doc = new jsPDF();
    doc.text("Simulação de Antecipação", 14, 10);

    const tableColumn = ["ID", "Descrição", "Valor da Parcela", "Data de Vencimento", "Desconto", "Valor Antecipado"];
    const tableRows = simplifiedParcels.map(parcel => ([
      parcel.id,
      parcel.description,
      formatCurrency(parcel.value),
      parcel.due_date,
      formatCurrency(parcel.newValueDiscount),
      formatCurrency(parcel.anticipate_value),
    ]));


    tableRows.push([
      '',
      'Total:',
      formatCurrency(totalValue),
      '',
      formatCurrency(totalDiscount),
      formatCurrency(totalAnticipate),
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      theme: 'striped',
      headStyles: { fillColor: [0, 0, 0] },
      styles: { fontSize: 10 },
    });

    doc.save('antecipadas.pdf');
  }


  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          footer="Total:"
          colSpan={2}
          footerStyle={{ textAlign: "right" }}
        />
        <Column footer={formatCurrency(totalValue)} />
        <Column
          footer=""
          footerStyle={{ textAlign: "right" }}
        />


      </Row>
    </ColumnGroup>
  );
  const footerGroupAnticipate = (
    <ColumnGroup>
      <Row>
        <Column
          footer="Total:"
          colSpan={2}
          footerStyle={{ textAlign: "right" }}
        />
        <Column footer={formatCurrency(totalValue)} />
        <Column
          footer=""

          footerStyle={{ textAlign: "right" }}
        />
        <Column footer={formatCurrency(totalDiscount)} footerStyle={{ fontSize: "13px" }} />
        <Column footer={formatCurrency(totalAnticipate)} footerStyle={{ fontSize: "13px" }} />

      </Row>
    </ColumnGroup>
  );

  return (
    <>
      <Modal
        dynamicTitle="Antecipar Parcelas Selecionadas"
        id="modal_cad"
        onHide={() => {
          setIsVisibleConfirm(false)
          reset();
          setIsModalVisibleAnticipateSelected(
            !isModalVisibleAnticipateSelected
          );
          setItemsSelected([]);
          setSelectAll([]);
          setShowAnticipateValueColumn(false);
        }}
        visible={isModalVisibleAnticipateSelected}
        style={style}
      >
        <Divider align="left">
          <div className="inline-flex align-items-center">
            <i className="pi pi-user mr-2"></i>
            <b> Calcular Antecipação</b>
          </div>
        </Divider>
        <form onSubmit={handleUpdateParcel(sendUpdate)}>
          <div className="mb-2">
            <div className="row">
              <div className="col-md-6">
                <CalendarInput
                  minDate={new Date()}
                  type="textarea"
                  className="p-inputtext-sm rounded-4"
                  label="Data de Pagamento"
                  onChange={(e) => {
                    setIsCalculateClicked(true);
                  }}
                  errors={errors}
                  isRequired={true}
                  control={control}
                  name="payment_date"
                  rows={4}
                  cols={30}
                />
              </div>
              <div className="col-md-3 d-flex justify-content-end align-items-end">
                <Button
                  rounded
                  label="Calcular"
                  icon="fa-solid fa-calculator"
                  type="submit"
                  loading={loading}
                  className="p-inputtext-sm ml-2"
                // onClick={handleConfirmButtonClick}
                />
              </div>
            </div>
          </div>
          <div className="mt-4">
            <h3>Parcelas Selecionadas</h3>
          </div>
          <div className="text-center mt-3 d-flex justify-content-end">
            <Button
              type="button"
              className="rounded-5"
              severity="success"
              aria-label="Bookmark"
              data-pr-tooltip="XLS"
              icon={<Excel />}
              onClick={exportToExcel}
            />
            <Button
              type="button"
              className="rounded-5"
              severity="secondary"
              icon="fa-solid fa-file-pdf"
              aria-label="Bookmark"
              data-pr-tooltip="PDF"
              onClick={exportToPDF}
              style={{ marginLeft: '8px' }}
            />
          </div>
          <div className="px-0 py-3">
            <DataTable
              scrollable
              scrollHeight="300px"
              stripedRows
              showGridlines
              sortMode="multiple"
              selectionMode="multiple"
              value={simplifiedParcels}
              footerColumnGroup={showAnticipateValueColumn ? footerGroupAnticipate : footerGroup}
              emptyMessage="Nenhuma Informação foi encontrada."
              tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
            >
              {columns.map((col) => (
                <Column
                  key={col.field}
                  field={col.field}
                  header={col.header}
                  body={col.body}
                />
              ))}
              {showAnticipateValueColumn && (

                <Column
                  field="newValueDiscount"
                  header="Desconto"
                  body={(rowData) => formatCurrency(rowData.newValueDiscount)}
                />
              )}
              {showAnticipateValueColumn && (
                <Column
                  field="anticipate_value"
                  header="Valor Antecipado"
                  body={(rowData) => formatCurrency(rowData.anticipate_value)}
                />

              )}
            </DataTable>
          </div>

          <div className="text-center mt-3">
            <Button
              rounded
              disabled={isCalculateClicked}
              visible={isVisibleConfirm}
              label="Confirmar Antecipação"
              icon="fa-solid fa-calculator"
              className="p-inputtext-sm m-auto"
              onClick={handleUpdateParcel(sendAnticipate)}
            />
          </div>
        </form>
      </Modal >
    </>
  );
};

export default ModalAnticipateSelectedInstallments;
